import dynamic from "next/dynamic";
import { UserSingleSelectProps } from "./SingleUserSelect";

export const SingleUserSelect = dynamic<UserSingleSelectProps>(
  () => import("./SingleUserSelect").then((mod) => mod.SingleUserSelectRaw),
  {
    ssr: false,
  }
);
